import { render, staticRenderFns } from "./TriageCalculationGeneralInformation.vue?vue&type=template&id=8f15fd1e"
import script from "./TriageCalculationGeneralInformation.vue?vue&type=script&lang=ts"
export * from "./TriageCalculationGeneralInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports